import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';
import { ContextGraphNodeSearchResult } from '@/types/context-graph-types';

export const searchContextGraphNodes = async (
  graphId: string,
  query: string,
  limit = 25,
): Promise<ContextGraphNodeSearchResult> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const params = new URLSearchParams({ q: query, limit: String(limit) });
  const response = await apiRequest<ContextGraphNodeSearchResult>({
    url: `/context-graphs/${orgId}/${graphId}/nodes/search?${params}`,
    method: 'GET',
    target: 'platform',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }
  if (!response.data) {
    throw new Error('Unexpected response format');
  }
  return response.data;
};
